import { PlayerUpdateEvent } from "../../types/public";

export const enum UiSize {
  Small,
  Medium,
  Large
}

export type SetPlayingRecommendation = (
  playingRecommendationIndex: number
) => void;

export type CommonCardProps = {
  language: string;
  newPlayerUi: boolean;
  setPlayingRecommendation: SetPlayingRecommendation;
  uiSize: UiSize;
  update: PlayerUpdateEvent;
};

export const getUiSize = (uiSizeInPx: number): UiSize =>
  uiSizeInPx < 704
    ? UiSize.Small
    : uiSizeInPx < 850
      ? UiSize.Medium
      : UiSize.Large;
